import ExtendFieldSelector from './src/main';

/* istanbul ignore next */
ExtendFieldSelector.install = function(Vue) {
  Vue.component(ExtendFieldSelector.name, ExtendFieldSelector);
};

export default ExtendFieldSelector;
